<div class="d-flex align-items-center w-100 flex-column spacing-16 justify-content-center">
  <img
    class="w-100"
    height="231"
    width="505"
    ngSrc="/assets/nodata-img.svg"
    priority
    alt="No data illustration" />
  <div class="d-flex flex-column spacing-16 align-items-center">
    <h2 class="h2-subheaders primary-100">{{ title }}</h2>
    <span class="h3-reg primary-60">{{ message }}</span>
  </div>
</div>
